import BulkInventoryUpload from "../../../views/BulkInventoryUpload";
import MenuNames from "../../../constants/Menu/MenuNames.json";

const BulkInventoryUploadRoutes = [
  {
    menuName: MenuNames.SPIN_THE_WHEEL,
    path: "/bulk-inventory-upload",
    component: BulkInventoryUpload,
    exact: true,
  },
];

export default BulkInventoryUploadRoutes;
